// extracted by mini-css-extract-plugin
module.exports = {"titleArea":"FormTitle_titleArea__1FWOQ","starterText":"FormTitle_starterText__NdYzb","headerText":"FormTitle_headerText__17mXl","subText":"FormTitle_subText__2pvDO"};